import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../index'

const selectNotificationsById = (state: RootState) => state.notifications.byId
const selectNotificationsAllIds = (state: RootState) => state.notifications.allIds

export const selectAllNotifications = createSelector(
    [selectNotificationsById, selectNotificationsAllIds],
    (byId, allIds) => allIds.map((id: string) => byId[id]).filter(Boolean)
)

export const selectHasUnwatched = createSelector(
    [selectNotificationsById, selectNotificationsAllIds],
    (byId, allIds) => allIds.some((id: string) => byId[id] && !byId[id].watched)
)

const selectAllNotificationsFullById = (state: RootState) => state.notifications.allByIdFull
const selectAllNotificationsFullIds = (state: RootState) => state.notifications.allIdsFull

export const selectAllNotificationsFull = createSelector(
    [selectAllNotificationsFullById, selectAllNotificationsFullIds],
    (byId, allIds) => allIds.map((id: string) => byId[id]).filter(Boolean)
)

export const selectNotificationsLoadingFull = (state: RootState) => state.notifications.loadingFull
